import fetch from 'cross-fetch';

type Address = string;

export async function getTopTokens() {
  const topTokens = (await (await fetch('https://cache.jup.ag/top-tokens')).json()) as Address[];

  return new Set(topTokens.filter((_, idx) => idx < 60));
}
